import { useI18n } from "@/context/I18nContext";

export default function Wallets({ state }) {
  const { t } = useI18n();
  const exchanges = state?.exchanges || {};
  const entries = Object.entries(exchanges);

  return (
    <div className="mq-panel" data-testid="wallets-panel">
      <div className="mq-panel-header">
        <span className="mq-heading text-sm font-semibold tracking-wider">
          {t("wallets")}
        </span>
        <span className="mq-label">{entries.length} EX</span>
      </div>
      <div className="max-h-[280px] overflow-y-auto">
        {entries.length === 0 ? (
          <div className="p-4 text-xs text-[var(--mq-text-3)]">{t("noData")}</div>
        ) : (
          entries.map(([exName, ex]) => {
            const balances = ex?.balances || {};
            const bEntries = Object.entries(balances).filter(([, v]) => Number(v) > 0);
            const balanceError = ex?.balance_error || "";
            const bookError = ex?.book_error || "";
            const tickerError = ex?.ticker_error || "";
            const publicFailed = !!ex?.public_failed;
            const hasCreds = ex?.has_credentials;
            const apiOk = !!ex?.api_connected;
            const live = ex?.live_trading_enabled;
            // LIVE = has creds + real API contact confirmed + trading authorised.
            const showLive = hasCreds && apiOk && live;
            return (
              <div key={exName} className="border-b last:border-0" style={{ borderColor: "var(--mq-border)" }} data-testid={`wallet-ex-${exName}`}>
                <div className="px-4 py-2 flex items-center justify-between bg-black/40">
                  <span className="mq-label" style={{ color: "var(--mq-cyan)" }}>
                    {exName.toUpperCase()}
                    {hasCreds && (
                      <span
                        className="ml-2 mq-label"
                        style={{ color: showLive ? "var(--mq-green)" : apiOk ? "var(--mq-yellow)" : "var(--mq-text-3)" }}
                      >
                        · {showLive ? "LIVE" : apiOk ? "READ-ONLY" : balanceError ? "AUTH FAIL" : "CONNECTING"}
                      </span>
                    )}
                  </span>
                  <span className="mq-label">
                    {ex?.exchange_health?.ok ? "● ONLINE" : "○ DEGRADED"}
                  </span>
                </div>
                {balanceError && (
                  <div
                    data-testid={`wallet-error-${exName}`}
                    className="px-4 py-2 text-[10px] border-l-2"
                    style={{ borderColor: "var(--mq-red)", color: "var(--mq-red)", background: "rgba(255,64,64,0.06)" }}
                    title={balanceError}
                  >
                    BALANCE FETCH FAILED · {balanceError}
                  </div>
                )}
                {(bookError || publicFailed) && (
                  <div
                    data-testid={`wallet-book-error-${exName}`}
                    className="px-4 py-2 text-[10px] border-l-2"
                    style={{ borderColor: "var(--mq-yellow)", color: "var(--mq-yellow)", background: "rgba(255,200,0,0.06)" }}
                    title={bookError || tickerError}
                  >
                    PAIR NOT AVAILABLE · {bookError || tickerError || "fallback simulator in use — prices NOT real"}
                  </div>
                )}
                {bEntries.length === 0 && !balanceError ? (
                  <div className="px-4 py-2 text-[10px] text-[var(--mq-text-3)]">
                    {hasCreds ? "no balances (0) on this account" : "no creds — read-only"}
                  </div>
                ) : (
                  bEntries.map(([asset, amt]) => (
                    <div key={`${exName}-${asset}`} className="flex items-center justify-between px-4 py-1.5 text-sm">
                      <span className="mq-label">{asset}</span>
                      <span className="font-mono">{Number(amt).toLocaleString(undefined, { maximumFractionDigits: 6 })}</span>
                    </div>
                  ))
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
